/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import React from 'react';
import PopupMessage from 'material/message/popup/popup_container';



/* ========== ~~~~~~~~~~ MESSAGE : POPUP : DELETE : CHILD ~~~~~~~~~~ ========== */
// PRESENTATIONAL COMPONENT
// receives app state & actions as props from parent "_container" component
// also receives two call back functions to route user
// this child component handles local state and uses props passed from parent to read/write application state when necessary
// Message specific component.
const DeleteMessage = (props) => (
    <PopupMessage
        type={'delete'}
        title={'Delete Confirmation'}
        body={<p>Are you sure you want to delete {props.itemType && props.itemName ? <span>the {props.itemType} <strong className={'clump'}>"{props.itemName}"</strong>?</span> : <span>this item?</span>}</p>}
        buttonPrimary={{ text: 'Delete', variant: 'delete', action: props.primaryAction }}
        buttonSecondary={{ text: 'Cancel', variant: 'system', action: props.secondaryAction }}
    />
);



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
// will be utilized in parent component after being infused with app state & actions
export default DeleteMessage;